import {
  selStatMemberLastSomeDay,
  selStatMemberByUserType,
  selStatMember,
  selStatMemberArea,
  selCustomerMoney,
  selUserDataInfo,
} from '@/api/statMember';

export default {
  namespaced: true,
  actions: {
    // 查询累计用户总数、最近一天新增用户总数、最近7天新增用户总数、最近30天新增用户总数
    async selStatMemberLastSomeDay(context, params) {
      const { data } = await selStatMemberLastSomeDay(params);
      return data;
    },
    // 按用户类型分类查询用户数
    async selStatMemberByUserType(context, params) {
      const { data } = await selStatMemberByUserType(params);
      return data;
    },
    // 查询按日期统计用户数据指标
    async selStatMember(context, params) {
      const { data } = await selStatMember(params);
      return data;
    },
    // 查询用户活跃地区排行榜
    async selStatMemberArea(context, params) {
      const { data } = await selStatMemberArea(params);
      return data;
    },
    // TOP10门店订货排行榜
    async selCustomerMoney(context, params) {
      const { data } = await selCustomerMoney(params);
      return data;
    },
    // 用户分布
    async selUserDataInfo(context, params) {
      const { data } = await selUserDataInfo(params);
      return data;
    },

  }
}
